import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DynamicCssService } from '../../services/dynamic-css.service';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit {
  constructor(private dynamicCss: DynamicCssService) {}

  ngOnInit() {
    document.body.style.opacity = '0';
    this.dynamicCss.loadStylesheetLink('public.css', 'public-css').then(() => {
      document.body.style.opacity = '1';
    });
  }
}
